<template>
    <div class="box full">
        <div class="device-status">
            <div class="title">
                <div @click="$router.go(-1)"><img src="../../../public/images/index/jiantou.svg" alt=""></div>
                <div class="margin-left-10">电梯数据监控</div>
            </div>
            <!-- 电梯数据监控 -->
            <div class="full elev-emulation-box tab-pane flex-container-row"  id="emulation">
                <div class="elev-btn-panal outer-call flex-container-column">
                    <div class="btn-box-title">{{$t('l.outbound_situation')}}</div>
                    <div class="btn-box" id="out_btn_box">
                        <display-btns :list="btnList" who="out"></display-btns>
                    </div>
                </div>
                <div class="elev-emulation-car">
                    <div class="elev-emulation-car-box">
                        <div class="elev-out-ground"></div>
                        <div class="elev-doors"
                             :class="{open:open}">
                            <!-- 左右两侧门 -->
                            <div class="elev-door elev-door-left"></div>
                            <div class="elev-door elev-door-right"></div>
                        </div>
                        <div class="elev-car"></div>
                        <div class="elev-floor-display">
                            <div class="floor-display-num">
                                {{lift_state.floor_current?device.j_floors.display[parseInt(lift_state.floor_current)-1]:''}}
                            </div>
                            <div class="floor-display-direction" v-if="lift_state.run_up||lift_state.run_down">
                                <div class="dir-icon"
                                     :class="{up: lift_state.run_up == 1, down: lift_state.run_down == 1}"></div>
                            </div>
                        </div>
                    </div>
                    <div class="running-text">
                        <div>
                        <span class="device-status-label">状态：</span>
                        <span >{{device.online?"在线":'离线'}}</span>
                        </div>
                        <div>
                        <span class="device-status-label">急停回路：</span>
                        <span>{{lift_state.scram_circuit==1?'闭合':'断开'}}
                        </span>
                        </div>
<!--                        <div><span class="device-status-label">速度(m/s)：</span>-->
<!--                        <span>{{lift_state.running_speed?lift_state.running_speed:0}}-->
<!--                        </span>-->
<!--                        </div>-->
                        <div><span class="device-status-label">是否故障：</span>{{lift_state.run_fault==1?'是':'否'}}</div>
                        <div v-if="lift_state.run_fault==1"><span class="device-status-label">故障码：</span>{{lift_state.fault_no}}</div>
                    </div>
                </div>
                <div class="elev-btn-panal inner-choose flex-container-column">
                    <div class="btn-box-title">{{$t('l.in_select_case')}}</div>
                    <div class="btn-box" id="in_btn_box">
                        <display-btns :list="btnList" who="in"></display-btns>
                    </div>
                </div>
            </div>
        </div>
        <div class="device-info">
            <div class="title">
                <div>详细信息</div>
            </div>
            <div class="device-detail ">
                <ul>
                    <li><span class="device-status-label"> 设备名称：</span>{{device.name}}</li>
                    <li><span class="device-status-label">项目名称：</span>
                        <span
                            v-if="device.j_location&&device.community&&device.community.name"
                            class="elev-info-value">
                                                {{device.community.name}}
                                                <template v-if="device.j_location&&device.j_location.building">
                                                {{device.j_location.building.name?device.j_location.building.name:''}}
                                                </template>
                                                <template v-if="device.j_location&&device.j_location.unit">
                                                    {{device.j_location.unit.name?device.j_location.unit.name:''}}
                                                </template>
                                            </span>
                    <span v-else>{{$t('l.no_data')}}</span>
                    </li>
                    <li><span class="device-status-label">设备位置：</span>{{address}}</li>
                    <li><span class="device-status-label">设备编号：</span>{{device.code||$t('l.no_data')}}</li>
                    <li><span class="device-status-label">设备型号：</span>{{device.model||$t('l.no_data')}}</li>
                    <li><span class="device-status-label">终端ID：</span>{{device.terminal_id||$t('l.no_terminal_id')}}</li>
                    <!--<li><span class="device-status-label">振动噪声监测终端：</span>{{device.terminal_id_curve||$t('l.no_terminal_id')}}</li>-->
                    <li><span class="device-status-label">生产厂商：</span>{{device.brand?device.brand:device.factory_name?device.factory_name:'未配置'}}</li>
                    <li><span class="device-status-label">小区名称：</span>{{device.community_name?device.community_name:'未配置'}}</li>
                    <li><span class="device-status-label">额定速度（m/s）：</span>{{device.device_param&&device.device_param.rated_speed?device.device_param.rated_speed:'未配置'}}</li>
                    <li><span class="device-status-label">额定载重（kg）：</span>{{device.device_param&&device.device_param.rated_load?device.device_param.rated_load:'未配置'}}</li>
                    <li><span class="device-status-label">贯通门：</span>{{device.device_param&&device.device_param.is_through_door===1?$t('l.yes'):$t('l.no')}}</li>
                    <li><span class="device-status-label">维保人：</span><span v-if="device.j_mt_workers&&device.j_mt_workers.length">
                                                <span v-for="(item,i) in device.j_mt_workers"
                                                      :key="item.mobile">
                                                    <span class="elev-info-value">
                                                        <span v-if="i">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        {{$t('l.name')}}：【{{item.name}}】，{{$t('l.phone_no')}}：【{{item.mobile}}】</span><br/>
                                                </span>
                                            </span>
                        <span v-if="!device.j_mt_workers||!device.j_mt_workers.length">{{$t('l.no_data')}}</span></li>
                    <li><span class="device-status-label">告警人：</span> <span v-if="device.j_alarm_charger&&device.j_alarm_charger.length">
                                               <span v-for="(item,i) in device.j_alarm_charger"
                                                     :key="item.mobile">
                                                   <span>
                                                       <span v-if="i">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                       {{$t('l.name')}}：【{{item.name}}】，{{$t('l.phone_no')}}：【{{item.mobile}}】
                                                   </span><br/>
                                               </span>
                                            </span>
                        <span v-if="!device.j_alarm_charger||!device.j_alarm_charger.length">{{$t('l.no_data')}}</span>
                    </li>
                    <!--<li>负责人： <span v-if="device.j_fzrs&&device.j_fzrs.length">-->
                                               <!--<span v-for="(item,i) in device.j_fzrs"-->
                                                     <!--:key="item.mobile">-->
                                                   <!--<span>-->
                                                       <!--<span v-if="i">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
                                                       <!--{{$t('l.name')}}：【{{item.name}}】，{{$t('l.phone_no')}}：【{{item.mobile}}】-->
                                                   <!--</span><br/>-->
                                               <!--</span>-->
                                            <!--</span>-->
                        <!--<span v-if="!device.j_fzrs||!device.j_fzrs.length">{{$t('l.no_data')}}</span></li>-->
                    <li><span class="device-status-label">{{$t("l.note")}}：</span>
                        <div style="display: grid">
                           <span class="elev-info-value">
                                                <span style="display: block">
                                                    <template
                                                            v-if="device.terminal_id&&device.terminal_id.startsWith('E')">
                                                        <span v-if="device.remark&&device.remark.mt_man">姓名：【{{device.remark.mt_man}}】</span>
                                                        <span v-if="device.remark&&(device.remark.mt_mobile||device.remark.mt_phone)">电话：【{{device.remark.mt_mobile?device.remark.mt_mobile:device.remark.mt_phone?device.remark.mt_phone:''}}】</span>
                                                    </template>
                                                    <template v-else>{{device.remark}}</template>
                                                </span>
                                                </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <Spin fix v-if="pageLoading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>{{$t('l.loading1')}}</div>
        </Spin>
    </div>
</template>

<script>
    import util from '@/libs/util.js';
    import ws from '@/libs/websocket';
    import displayBtns from './component/display-btns';

    export default {
        name: "m_monitor",
        components:{displayBtns},
        data() {
            return {
                device: {},
                pageLoading: false,
                getStatusTimer: null,
                open: false,
                lift_state:{},
                btnList: [],
                timer:null,
                terminalMessageTimer: {}, // 终端设备回复的定时器
            }
        },
        methods: {
            onInitial() {
                util.page_monitor = this;
                let deviceId = this.$route.params.id || sessionStorage.getItem("deviceId");
                sessionStorage.setItem('device-page', this.$route.params.page || 1);
                sessionStorage.setItem("deviceId", deviceId);
                if (deviceId) {
                    this.getLift(deviceId);
                }
                ws.on('up_report_status', this.onStatus.bind(this), 0); // 渲染 当前设备运行状态信息
                ws.on('status_report', (message) => {   // 获取当前设备是否在线
                    if (message.deviceName === this.device.terminal_id) {
                        this.device.j_param.status = message.status;
                        this.device.online = message.status === 'online' ? 1 : 0;// MARK_MODIFY_ONLINE20200525
                    }
                }, 0);
            },
            onStatus(message) {
                if ((message.deviceName !== this.device.terminal_id)&&(message.deviceName!=this.device.terminal_id_curve)) return;
                this.pageLoading = false // 加载loading。。。。
                this.lift_state = typeof message.data == "string" ? JSON.parse(message.data):message.data;
                this.lift_state.time = message.timestamp ? `[ ${new Date(message.timestamp).pattern('yyyy-MM-dd HH:mm:ss')} ]` : '';
                message.data.floor_down_selected = util.parseJSON(message.data.floor_down_selected, []);
                message.data.floor_up_selected = util.parseJSON(message.data.floor_up_selected, []);
                message.data.floor_selected = util.parseJSON(message.data.floor_selected, []);
                // if (message.data.run_status && message.data.run_status == 6) this.deviceControlLock = false;
                // else this.deviceControlLock = true;
                // if (message.data.remote_stop && message.data.remote_stop == 1) this.deviceControlStop = false;
                // else this.deviceControlStop = true;
                // 设置当前楼层
                this.lift_state.floor_current = this.device.j_floors.display[parseInt(message.data.floor_current)-1];
                this.setBtnLights(message.data);
                this.setDoorOpenState();
            },
            //请求 mqtt
            getLift(id) {
                util.ajax.get('/device/getbyid', {
                    params: {
                        id: id
                    }
                }).then((res) => {
                    if (!res.code) {
                        util.parseJSONResult(res.data, 'device_param');
                        util.parseJSONResult(res.data, 'push_log');
                        util.parseJSONResult(res.data, 'j_floors');
                        if (!res.data.device_param) res.data.device_param = {
                            is_through_door: 0,
                            rated_speed: '-',
                            rated_load: '-',
                            type: '-'
                        };
                        this.device = res.data;
                        this.setBtnList();
                        if (this.device.vm_device_id) this.device.terminal_id = this.device.vm_device_id
                        if (this.device.terminal_id && this.device.terminal_id.startsWith('E') && res.data.remark) {
                            this.device.remark = JSON.parse(res.data.remark);
                        }
                        if (ws.isConnected()) this.startMonitor(this.device.terminal_id, this.timer);
                        ws.on('on-reconnect', () => {
                            if (typeof this.timer === 'number') this.startMonitor(this.device.terminal_id, this.timer);
                        })
                    } else {
                        this.$Message.warning(this.$t('l.remark122'))
                    }
                }).then(() => {
                    if (this.device.isExpire == 1 && this.device.online) this.pageLoading = true
                    this.getStatusTimer = setTimeout(() => {
                        if (this.pageLoading) {
                            this.$Message.warning(this.$t('l.remark123'))
                            this.pageLoading = false;
                        }
                    }, 5000)
                });
            },
            setDoorOpenState() {
                let s = this.lift_state;
                // if (this.device.terminal_id.startsWith("E")) {
                    if (s.door_circuit == 1) this.open = false;
                    else this.open = true;
                // } else {
                //     if (s.front_door_closing == 1 || s.front_door_closed == 1 || s.back_door_closing == 1 || s.back_door_closed == 1) this.open = false;
                //     else if (s.front_door_opening == 1 || s.back_door_opening == 1 || s.front_door_opened == 1 || s.back_door_opened == 1) this.open = true;
                // }
            },
            //    开启定时器
            startMonitor(terminal_id,timer) {
                if ((terminal_id && this.device.online == 1 && this.device.isExpire==1)) { // MARK_MODIFY_ONLINE20200525
                    //  设备 保证有terminal_id  并且保证设备在线
                    ws.addSubscibeToLift(terminal_id, 'subscribe');
                    ws.sendMessage('down_get_status', [terminal_id]);
                    if (timer) clearInterval(timer)
                    new Promise((resolve, reject) => {
                        if (this.$store.state.app.lift_state_param_settings) {
                            resolve();
                        } else {
                            util.ajax.get('/settings/get').then(res => {
                                util.parseJSONResult(res.data);
                                this.$store.state.app.lift_state_param_settings = res.data;
                                resolve();
                            })
                        }
                    }).then(() => {
                        timer = setInterval(() => {
                            ws.sendMessage('down_get_status', [terminal_id]);
                        }, 1000 * this.$store.state.app.lift_state_param_settings.j_monitor_config.config.page_detail.keep)
                    })
                }
            },
            setBtnList() {
                let j_floors = this.device.j_floors;
                this.btnList = j_floors.display.map((dis, i) => {
                    return {
                        absIndex: i, // 绝对楼层（1开始）
                        display: dis, // 显示楼层
                        unstop: j_floors.unstop.includes(i), //
                        out: 0, // 0无，1上，2下,3上下
                        in: 0 // 0无，1选
                    }
                });
            }
        },
        computed: {
            address() {
                if (this.device.address) {
                    return this.device.address;
                }
                else {
                    let community = this.device.community;
                    if (!community) return this.$t('l.no_specific_location');
                    let j_region = community.j_region ? JSON.parse(community.j_region) : null;
                    if (community && j_region) {
                        return (j_region.province ? j_region.province.name : "") + (j_region.city ? j_region.city.name : '') + (j_region.area ? j_region.area.name : '') + (community.caddress ? community.caddress : '');
                    }
                    else return this.$t('l.no_specific_location');
                }
            },
            liftTypes() {
                return [this.$t('l.lift_type1'), this.$t('l.lift_type2'), this.$t('l.lift_type3'), this.$t('l.lift_type4')];
            },
        },
        watch: {
        },
        created() {
            ws.init();
            this.onInitial();
        }
    }
</script>

<style scoped lang="less">
    .box {
        background-color: #ecf0f1;
        .device-status{
            height: 60%;
            width: 100%;
            &-text{
                width: calc(40% - 10px);
                margin-left: 10px;
                color:#7f8c8d;
                height: 100%;
                font-size: 14px;
                margin-top: 10%;
                margin-top: 30px;
                p{
                    margin: 10px 0;
                }
            }
            &-label{
                font-weight: 600;
            }
            .elev-emulation-box{
                display: flex;
                align-items: center;
            }
            .elev-emulation-car {
                position: relative;
                width: 50%;
                height: 100%;
                &-box{
                    height: 80%;
                    width: 100%;
                }
                .running-text{
                    width: 100%;
                    height: 20%;
                    display: grid;
                    margin-left: 7px;
                    align-items: center;
                    grid-template-columns: 1fr 1fr;
                }
            }
            .elev-emulation-car .elev-out-ground {
                width: 100%;
                height: 80%;
                background-size: 100% 100%;
            }
            .elev-emulation-car .elev-car {
                width: 100%;
                height: 80%;
                background-size: 100% 100%;
                position: absolute;
                left: 0;
                top: 0;
            }
            .elev-doors {
                position: absolute;
                width: 36%;
                height: 55%;
                left: 50%;
                margin-left: -18%;
                top: 20%;
                overflow: hidden;
            }

            .elev-doors .elev-door {
                background-size: 100% 100%;
                width: 50%;
                height: 100%;
                position: absolute;
                top: 0;
                transition-property: left, right;
                transition-duration: 2.4s, 2.4s;
                transition-timing-function: ease;
            }
            .elev-door-left {
                left: 0;
            }

            .elev-door-right {
                right: 0;
            }

            .elev-doors.open .elev-door-left {
                left: -40%;
            }

            .elev-doors.open .elev-door-right {
                right: -40%;
            }
            .elev-car {
                background-image: url(/images/device/lift.png);
            }

            .elev-out-ground {
                background-image: url(/images/device/back.jpg);
            }

            .elev-door-left {
                background-image: url(/images/device/door-left.png);
            }

            .elev-door-right {
                background-image: url(/images/device/door-right.png);
            }
        }
        .device-info{
            height: 40%;
            width: 100%;
            position: relative;
            margin-top: 30px;
        }
        .device-detail {
            overflow-y: auto;
            height: calc(100% - 30px);
            wdith: 100%;
            ul{
                list-style: none;
                color:#7f8c8d;
                margin-left: 10px;
                li{
                    margin: 5px 0;
                }
            }
        }
        .title {
            height: 30px;
            color: #fff;
            font-weight: 600;
            background: #5cadff;
            line-height: 30px;
            font-size: 14px;
            display: flex;
            align-items: center;
            div{
                height: 100%;
            }
            img{
                width: 18px;
                margin-top: 5px;
            }
        }
        .elev-floor-display {
            background-color: #333;
            width: 4.3em;
            height: 1.6em;
            border-radius: 4px;
            margin-left: -2.5em;
            overflow: hidden;
            cursor: default;
            position: absolute;
            top: calc(14.5% + 1px);
            left: 53%;
            color: yellow;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            justify-content: center;
            align-items: center;
            &.invideo {
                top: 2%;
                left: 10%;
            }
            & > .floor-display-num {
                width: 26px;
                height: 26px;
                font-size: 20px;
                display: flex;
                justify-content: center;
                /*font-size: 22px;*/
                /*height: 100%;*/
                /*width: 100%;*/
                /*letter-spacing: 3px;*/
                /*line-height: 28px;*/
                /*font-family: 'signus_led';*/
                /*display: inline-block;*/
                /*text-indent: 0.5em;*/
                /*position: absolute;*/
                /*top: 2px;*/
                /*right: 30%;*/
            }
        }
        .floor-display-direction .dir-icon {
            position: absolute;
            left: 32px;
            background-size: 100% auto;
            background-repeat: no-repeat;
            display: block;
            width: 13px;
            height: 13px;
        }

        @keyframes displayUp {
            0% {
                top: 100%;
            }

            100% {
                top: -80%;
            }
        }

        @keyframes displayDown {
            0% {
                top: -80%;
            }

            100% {
                top: 100%;
            }
        }

        .floor-display-direction .dir-icon.up {
            background-image: url(/images/device/upgif.png);
            animation: displayUp 1.4s linear infinite;
        }

        .floor-display-direction .dir-icon.down {
            background-image: url(/images/device/downgif.png);
            animation: displayDown 1.4s linear infinite;
        }

        .floor-display-direction {
            /*display: inline-block;*/
            width: 20%;
            /*right: 8%;*/
            /*top: 25%;*/
            height: 50%;
            overflow: hidden;
            /*position: absolute;*/
        }

        .elev-btn-panal {
            width: 25%;
            height: 100%;
        }

        .elev-btn-panal .btn-box-title {
            color: #fff;
            font-size: 12px;
            text-align: center;
            width: 100%;
            height: 20px;
            line-height: 20px;
            background-color: #48dbfb;
        }

        .elev-btn-panal .btn-box {
            width: 100%;
            height: 100%;
            background-color: #dfecf4;
            overflow: auto;
        }

        .btn-box::-webkit-scrollbar {
            display: none;
        }
    }
</style>